import urlPrefix from "./apiPrefix";

export const getFDErrorInfoList = () => `${urlPrefix.value}/tax-web-control/api/fd-error-info/list`;
